import { Injectable } from '@angular/core';
import {User} from '../../models/user';
import {Store} from '@ngrx/store';
import * as AuthReducer from '../../store/auth/reducers';
import {CreateStudent} from '../../interfaces/requests/create-student';
import {HttpClient} from '@angular/common/http';
import {Observable} from '@node_modules/rxjs/Observable';
import {TeacherSubscription} from '@models/teacherSubscription';
import {RequestTeacherSubscription} from '@interfaces/requests/requestTeacherSubscription';

@Injectable({
  providedIn: 'root'
})
export class TeacherService {

  user: User;

  constructor(
    private httpClient: HttpClient,
    private authStore: Store<AuthReducer.AuthState>,
  ) {
    this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth && auth.user) {
          this.user = auth.user;
        }
      }
    );
  }

  getAll() {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.get(school_id+'/teacher/');
    }
    return new Observable();
  }
  getInvitedUsers() {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.get(school_id+'/student/invited?role=teacher');
    }
    return new Observable();
  }
  create(body: CreateStudent) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id+'/teacher/', body);
    }
    return new Observable();
  }
  addToClass(body: RequestTeacherSubscription) {
    return this.httpClient.post('teacher/class', body);
  }
  getTeachersSubscriptions(teacher_id: number) {
    return this.httpClient.get('teacher/subscription/' + teacher_id);
  }
  toggleSubscription(class_id: number, mode: string, teacher: User) {
    const body = {
      'teacher_id': teacher.id,
      'class_id': class_id,
      'mode': mode
    };
    return this.httpClient.put('teacher/subscription', body);

  }
  getSchoolsTeachers(school_id: number, page: number, programId = null, classId = null, selectedCurriculumId = null) {
    let url = 'teacher/school/' + school_id + '?page=' + page;
    if (programId) {
      url += '&program_id=' + programId;
    }
    if (classId) {
      url += '&class_id=' + classId;
    }
    if (selectedCurriculumId) {
      url += '&curriculum_id=' + selectedCurriculumId;
    }
    return this.httpClient.get(url);
  }
}
